import { useAuthStore } from '../store';
import type { AdminUser } from '../types';

interface UseAuthResult {
  user: AdminUser | null;
  isAuthenticated: boolean;
  isHydrated: boolean;
}

export function useAuth(): UseAuthResult {
  const user = useAuthStore((s) => s.user);
  const accessToken = useAuthStore((s) => s.accessToken);
  const isHydrated = useAuthStore((s) => s.isHydrated);
  return {
    user,
    isAuthenticated: Boolean(user && accessToken),
    isHydrated,
  };
}
